import {
    SYSTEM_SUBMIT_BENEFITS_BEGIN,
    SYSTEM_SUBMIT_BENEFITS_SUCCESS,
    SYSTEM_SUBMIT_BENEFITS_FAILURE,
    SYSTEM_SUBMIT_BENEFITS_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitBenefits(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: SYSTEM_SUBMIT_BENEFITS_BEGIN,
      });
  
      let apiurl = '/api/b/benefits/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/benefits/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: SYSTEM_SUBMIT_BENEFITS_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: SYSTEM_SUBMIT_BENEFITS_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitBenefitsError() {
    return {
      type: SYSTEM_SUBMIT_BENEFITS_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_SUBMIT_BENEFITS_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitBenefitsPending: true,
          submitBenefitsError: null,
        };
  
      case SYSTEM_SUBMIT_BENEFITS_SUCCESS:
        // The request is success
        return {
          ...state,
          submitBenefitsPending: false,
          submitBenefitsError: null,
        };
  
      case SYSTEM_SUBMIT_BENEFITS_FAILURE:
        // The request is failed
        return {
          ...state,
          submitBenefitsPending: false,
          submitBenefitsError: action.data.error,
        };
  
      case SYSTEM_SUBMIT_BENEFITS_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitBenefitsError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/system/redux/submitBenefits.js